
import PageLoading from '@/components/Shared/Loading/Preloader.vue'
import {
  buildPageHead,
  buildAnalyticsMeta,
  buildHeadScripts,
  metaPlainText,
} from '@/helpers/pageSeo'

export default {
  middleware: ['returnUrl', 'onlyRedirectProject'],
  async fetch({ store, app }) {
    const currency = store.getters['user/getUserIP'].currency
    await store.dispatch('popularProducts/GET_POPULAR_PRODUCTS', {
      currency,
      lang: app.i18n.locale,
    })
  },
  async asyncData({ store, route, redirect }) {
    const [baseUrl, ids, domain] = route.params.productId.split('-')
    const types = require('@/static/database/Types.json')
    const id = Number(ids)
    if (isNaN(id)) redirect('/error')
    const response = await store.dispatch('productDetail/GET_PRODUCT_TO_LIST', {
      url: `${baseUrl}/${id}?currency=${store.getters['user/getUserIP'].currency}`,
      id,
    })
    const product = response
      ? response
      : store.getters['productDetail/getProduct'](id)
    const activeComponent = types.find((t) => t.to === baseUrl).component
    return {
      activeComponent,
      product,
      type: types.find((t) => t.to === baseUrl),
    }
  },
  head() {
    if (!this.product || !this.type) {
      return { htmlAttrs: { lang: this.$i18n.locale } }
    }
    const base = (this.$store.state.settings.website || '').replace(/\/$/, '')
    const pageTitle = `${this.product.title} - ${this.$custom$t(`type.${this.type.name}`)} | ${this.$store.state.settings.title}`
    const { title, meta, link } = buildPageHead(this, {
      title: pageTitle,
      description: metaPlainText(this.product.description),
      image: this.$api.path(this.product.imagePath),
      canonicalHref: base + this.$route.path,
    })
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      title,
      meta: [...meta, ...buildAnalyticsMeta(this)],
      link,
      script: buildHeadScripts(this),
      __dangerouslyDisableSanitizers: ['script'],
    }
  },
  computed: {
    pageIsLoading() {
      return this.$store.state.productDetail.productListIsLoading
    },
  },
  components: {
    PageLoading,
    CourseContent: () => import('@/components/Contents/CourseContent'),
    CourseContentV2: () => import('@/components/Contents/CourseContent-V2'),
    BookContent: () => import('@/components/Contents/BookContent'),
    EventContent: () => import('@/components/Contents/EventContent'),
    SeanceContent: () => import('@/components/Contents/SeanceContent'),
    BlogContent: () => import('@/components/Contents/BlogContent'),
  },
}
